import { render, staticRenderFns } from "./CsRevisionTarifasVtoBno.vue?vue&type=template&id=cd8ec2a2"
import script from "./CsRevisionTarifasVtoBno.vue?vue&type=script&lang=js"
export * from "./CsRevisionTarifasVtoBno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports